/* eslint-disable quote-props */
/**
 * Configure requireJS
 */
require([
  'blackbox',
  'localizerInit',
  'jquery',
  'global.namespace',
  'cartridge',
  'digitalData',
  'global.digitalData_pattern',
  'hdc-widget-analytics',
  'auth.service',
  'secondary-data',
  'commission-junction',
  'PLPCART',
  'PLPQuantityBox',
  'video-overlay',
  'thd-client-throttle',
  'targeted.merchandise',
  'curationWidget',
  'verification.service',
  'global.modal',
  'global.toolTip',
  'account.list',
  'main.plp',
  'modernizr-custom',
  'PLPSEO',
], (
  blackbox,
  localizerInit,
  $,
  THD,
  cartridge,
  digitalDataWrapper,
  gddp,
  hwa,
  authService,
  secondaryData,
  commissionJunction,
  plpCart,
  plpQuantityBox,
  videoOverlay,
  clientThrottle,
  targetedMerchandise,
  curationWidget,
  verificationService,
  globalModal,
) => {
  // eslint-disable-next-line no-param-reassign, no-multi-assign
  THD.PLP = THD.PLP || {};

  if (typeof THD_GLOBAL_APP !== 'undefined') {
    $.extend(THD_GLOBAL || {}, THD_GLOBAL_APP);
  }

  plpCart.init();

  // Curation Initialization
  curationWidget.init();

  globalModal.init();

  secondaryData.init();
  authService.init();
  commissionJunction.updateCJInfo();
  gddp.init();
  digitalDataWrapper.init();
  hwa.init();
  cartridge.init();
  videoOverlay.init();
  targetedMerchandise.init();
  verificationService.init();
  plpQuantityBox.init();

  // edge includes has loads stuff through ajax if varnish isn not enabled
  $('.js-edgeinclude').each((i, el) => {
    const url = $(el).data('edgeinclude-url');

    $.ajax(url).done((res) => {
      $(el).html(res);
    });
  });
});
